import { useState } from "react"
import { changeSecurityQuestions } from "../services/Api";
import Menu from "components/Menu";
import RoundyContainer from "components/RoundyContainer";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from 'react-bootstrap';
import SettingsWindowSecurity from "components/SettingsWindowSecurity";

// Analogous to Settings.js
const Content = (props) => {
    const ErrorSecurityBlank = "Please select a security question and corresponding answer for all 3 drop-downs below."

    const { userData, setUserData } = props.user
    const [newVal, setNewVal] = useState([])
    const [error, setError] = useState("")
    const [loading, isLoading] = useState(false);

    const { zip, policyNumber } = props.user.userData
    const [changedVal, setChangedVal] = useState("")
    const navigate = useNavigate()

    const onSubmit = async () => {
        isLoading(true);
    
        var emptySecurityQuestions = newVal.filter(qaPair => qaPair.Code == "default" || qaPair.Answer == "")
        if (!newVal.length || emptySecurityQuestions.length) {
            setError(ErrorSecurityBlank)
            isLoading(false);
            return
        }

        console.log(props.showError)
        setError("")
        var params = {
            ZipCode: zip,
            PolicyNumber: policyNumber,
        }

        params["Questions"] = newVal
        console.log(params)
        var response = await changeSecurityQuestions(params)
        console.log(response)

        setError("");
        setChangedVal("security questions")
        isLoading(false);

        //Prevent popup from showing on homepage refresh after answering security questions
        setUserData({...userData, securityPopup: false})
    }

    return (
        <>
            <div className="row py-2">
                <div className="col-xs-4 col-sm-3">
                    <strong>Security Question</strong>
                </div>
                <div className="col-xs-8 col-sm-9 col-md-7">
                    Used for identity verification purposes<br />
                    <small>{changedVal.length > 0 &&
                        <p className={`row p-3 m-1 border bg-success border-success text-success`}>Your {changedVal} has been successfully changed!</p>}
                    </small>
                    {changedVal.length <= 0 && <div className="container-fluid p-3 pb-4 mt-3 d-flex flex-column grad-window">
                        {(error.length > 0) &&
                            <div className="text-alert text-center bg-alert border rounded-3 p-3 m-2 mb-3 border-alert">{error}</div>
                        }
                        <SettingsWindowSecurity
                            newVal={newVal}
                            setNewVal={setNewVal}
                        />
                        {!loading &&
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-secondary btn-sm m-1" onClick={() => navigate("/home")} >CANCEL</button>
                                <button className="btn btn-primary-grad btn-sm m-1" onClick={onSubmit}>CHANGE</button>
                            </div>
                        }
                        {/* Spinning Loader */}
                        {loading && 
                            <div>
                                <Spinner animation="border" style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}/>
                            </div>
                        }
                    </div>}
                </div>
            </div>

            <Link to="/home" className="col-sm-1">
                <button className="btn btn-default border">BACK</button>
            </Link>
        </>
    )
}

const SecurityQAs = (props) => {
    const { userData } = props.user
    return (
        <>
            <Menu Title={"MY ACCOUNT"} FirstName={userData.firstName} userData={userData} />
            <RoundyContainer params={props} Content={Content} />
        </>
    )
};

export default SecurityQAs